export function trackSponsoredListingClickUrl({ isSponsored, estabId }) {
    var _a;
    const getSponsoredListing = window.localStorage.getItem('sponsoredListingPL195');
    if (!estabId) {
        return;
    }
    if (getSponsoredListing) {
        const obj = JSON.parse(getSponsoredListing);
        (_a = obj === null || obj === void 0 ? void 0 : obj.sponsoredListing) === null || _a === void 0 ? void 0 : _a.forEach((sponsoredList) => {
            const { clickUrl, conversionUrl } = sponsoredList;
            if (sponsoredList && (sponsoredList === null || sponsoredList === void 0 ? void 0 : sponsoredList.estabId) === estabId && clickUrl) {
                fetch(clickUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (conversionUrl && estabId) {
                    const conversionUrlSponsoredListing = [];
                    conversionUrlSponsoredListing.push({ estabId, conversionUrl });
                    const isPL195CoversionUrl = {
                        isSponsored,
                        sponsoredListing: conversionUrlSponsoredListing,
                    };
                    const serialized = JSON.stringify(isPL195CoversionUrl);
                    window.sessionStorage.setItem('conversionUrlPL195', serialized);
                }
            }
        });
    }
}
